import * as tslib_1 from "tslib";
import { CarQuoteLitePolicyInfo } from '../../shared/models/car-quote-lite-policy-info.model';
import { StringExtensions } from 'app/modules/ca7-claim/helpers/string-extensions';
import { PaymentType } from '@sc/leads-admin/models';
import * as i0 from "@angular/core";
var CarQuoteLiteStorageService = /** @class */ (function () {
    function CarQuoteLiteStorageService() {
        this.isCarQuoteLiteDataSet = false;
        this.clear();
    }
    CarQuoteLiteStorageService.prototype.setRisk = function (risk) {
        this.risk = risk;
    };
    CarQuoteLiteStorageService.prototype.setPolicy = function (policy) {
        var newPolicy = tslib_1.__assign({}, this.policy, policy);
        this.policy = newPolicy;
    };
    CarQuoteLiteStorageService.prototype.setTaxes = function (taxes) {
        this.taxes = taxes;
    };
    CarQuoteLiteStorageService.prototype.setAffinityGroup = function (id, discount) {
        this.affinityGroupId = id;
        this.affinityGroupDiscount = discount;
    };
    CarQuoteLiteStorageService.prototype.clear = function () {
        this.draftId = null;
        this.risk = null;
        this.isCarQuoteLiteDataSet = false;
        this.paymentMethods = this.calculatePaymentMethods();
        var policy = new CarQuoteLitePolicyInfo();
        policy.paymentMethod = this.paymentMethods[0];
        policy.commercialAlternative = 0;
        policy.fee = { key: 6, value: '6', name: '6' };
        this.setPolicy(policy);
        this.taxes = null;
        this.affinityGroupDiscount = null;
        this.affinityGroupId = '';
        this.postalCode = null;
    };
    CarQuoteLiteStorageService.prototype.calculatePaymentMethods = function () {
        return [
            'Efectivo / Cheque',
            'Débito en tarjeta',
            'Débito en cuenta'
        ].map(function (each, index) { return ({
            paymentType: each,
            title: each,
            paymentTypeId: (index + 1).toString(),
            hideAmount: true
        }); });
    };
    CarQuoteLiteStorageService.prototype.setCarQuoteLiteData = function (data) {
        this.clear();
        if (data.riskData) {
            delete data.riskData.statedAmount;
            this.setVehicle(data);
            this.setRisk(data.riskData);
        }
        var policy = {
            commercialAlternative: data.commercialAlternative,
            automaticAdjustment: data.automaticAdjustment
        };
        this.setPolicy(policy);
        this.opportunityId = data.opportunitiesId;
        this.isCarQuoteLiteDataSet = true;
        data.postalCode && this.setPostalCode(data);
        data.quotes && data.quotes.length && this.setPaymentMethod(data.quotes[0]);
    };
    CarQuoteLiteStorageService.prototype.setPaymentMethod = function (data) {
        var paymentMethodId = 0;
        switch (data.paymentMethod) {
            case 'EFECTIVO':
                paymentMethodId = PaymentType.Efectivo;
                break;
            case 'CREDITO':
                paymentMethodId = PaymentType.Credito;
                break;
            case 'DEBITO':
                paymentMethodId = PaymentType.Debito;
                break;
        }
        this.policy.paymentMethod = this.paymentMethods[paymentMethodId];
        this.policy.fee = { key: data.paymentFee, value: data.paymentFee.toString(), name: data.paymentFee.toString() };
    };
    CarQuoteLiteStorageService.prototype.setVehicle = function (data) {
        data.riskData.year = (data.riskData.year) ? this.modelMapper((data.riskData.year).toString()) : null;
        data.riskData.make = this.modelMapper((data.riskData.makeKey));
        data.riskData.model = this.modelMapper((data.riskData.modelKey));
    };
    CarQuoteLiteStorageService.prototype.setPostalCode = function (location) {
        this.postalCode = {
            postalCode: location.postalCode.toString(),
            postalSynonym: location.cityKey,
            state: {
                key: location.stateKey,
                name: StringExtensions.toTitleCase(location.cityName)
            },
            key: location.postalCode + "-" + location.cityKey,
            name: StringExtensions.toTitleCase(location.cityName)
        };
    };
    CarQuoteLiteStorageService.prototype.getCommercialAlternativeByAffinity = function () {
        var commercialLabel = Math.abs(this.affinityGroupDiscount) + "% de " + ((Math.sign(this.affinityGroupDiscount) === -1) ? 'descuento' : 'recargo') + " en la prima";
        return {
            key: this.affinityGroupDiscount,
            value: commercialLabel,
            name: commercialLabel
        };
    };
    CarQuoteLiteStorageService.prototype.modelMapper = function (param) {
        return { key: param, name: param };
    };
    CarQuoteLiteStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CarQuoteLiteStorageService_Factory() { return new CarQuoteLiteStorageService(); }, token: CarQuoteLiteStorageService, providedIn: "root" });
    return CarQuoteLiteStorageService;
}());
export { CarQuoteLiteStorageService };
